<template>
  <div class="d-flex justify-content-center colony-list">
    <b-container>
      <b-row>
        <b-col v-if="((!loaded && !showError) || deleteProgress)" class="col-12 col-md-12 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <p class="text-center">{{ $t('colonies.error') }}</p>
          </b-card>
        </b-col>
        <b-col class="col-12 col-md-12 mb-3 position-relative" v-for="(colony, i) in data" :key="i">
          <b-card>
            <b-link class="d-block" :to="'/colony/' + colony.id + '/' + id">
              <h1 class="text-primary font-weight-bold text-center">{{ colony.title }}</h1>
            </b-link>
<!--            <div class="icon-crown_filled text-center" :style="{ color: colony.crownColor }">{{ colony.crownColor }}</div>-->
            <div class="text-center" :class="[(colony.crownColor ==='#fff') ? 'icon-crown' : 'icon-crown_filled']" :style="{ color: (colony.crownColor === '#fff')? '#D0D0D0' : colony.crownColor }"></div>
            <div class="action-row">
              <b-link class="text-body icon-pen" :title="$t('colony_edit.title')" @click.prevent="checkNetworkUpdate(colony.id)"></b-link>
            </div>
            <div class="action-row-delete">
              <colony-delete :queen="colony.queen" :id="colony.id" :apiary="colony.apiary" :key="i" @confirmDelete="onClickDelete($event)" :formList="true">></colony-delete>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-modal :id="'offLineModalColony'" centered hide-header-close @ok="hideModal">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import ColonyDelete from '../components/ColonyDelete'
import _ from 'lodash'

export default {
  name: 'ColonyList',
  components: { ColonyDelete },
  props: ['id'],
  data () {
    return {
      showError: false,
      deleteProgress: false,
      data: null,
      deleteClicked: null
    }
  },
  computed: {
    loaded () {
      return !!this.data
    }
  },
  methods: {
    checkNetworkUpdate (colonyId) {
      if (navigator.onLine) {
        this.$router.replace('/colony/edit/' + colonyId + '/' + this.id)
      } else {
        this.showOffLineModal()
      }
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalColony')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalColony')
    },
    onClickDelete (value) {
      const vm = this
      if (value) {
        const tempData = this.data
        this.data = null
        setTimeout(async function () {
          vm.data = _.filter(tempData, function (colony) {
            return colony.id !== value
          })
        }, 1000)
      }
    },
    async loadData () {
      const vm = this
      try {
        this.data = (await this.$api.colonies.getAll()).filter(function (row) {
          if (row.apiary !== vm.id) {
            return false
          }

          return (
            !row.field_massnahmen_und_aktionen ||
            Object.values(row.field_massnahmen_und_aktionen).filter(function (action) {
              return action.type === 'aktion_aufloesung' || action.type === 'aktion_vereinigung'
            }).length === 0
          )
        })
      } catch (e) { // network error etc.
        console.log(e)
        this.data = null
      }

      this.showError = !this.data
      return this.data
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .colony-list {
    font-family: "Roboto Condensed", sans-serif;

    h2 {
      font-size: 1.5rem;
    }

    .action-row {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.5rem;
      line-height: 1rem;

      > * {
        display: inline-block;
        padding: 0.5rem 0.75rem;

        &:hover {
          text-decoration: none;
          background-color: $secondary-light;
        }
      }
    }

    .icon-crown_filled, .icon-crown {
      font-size: 2rem;
    }
    .link-titel {
      text-decoration: underline;
      font-weight: bold;
    }
    .card-body {
      padding: 1.25rem;
    }
    .card-body h1{
      font-size: 2rem;
      font-family: $font-family-base;
    }
    .action-row-delete {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 1.5rem;
      line-height: 1rem;

      > * {
        display: inline-block;
        padding: 0.5rem 0.75rem;

        &:hover {
          text-decoration: none;
          background-color: $secondary-light;
        }
      }
    }
  }
</style>
